import { getUserManager } from '@/lib/oidcClient';
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { getValidAccessToken } from './auth-token';

const authLink = setContext(async (_, { headers, skipAuth }) => {
    if (skipAuth) {
        return { headers };
    }

    const token = await getValidAccessToken();
    return token
        ? {
              headers: {
                  ...headers,
                  authorization: token ? `Bearer ${token}` : '',
              },
          }
        : headers;
});

const httpLink = createHttpLink({
    uri: process.env.NEXT_PUBLIC_API_URL,
});

const errorLink = onError(({ networkError }) => {
    if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
        if (typeof window !== 'undefined') {
            const manager = getUserManager();

            manager.signoutRedirect({
                extraQueryParams: {
                    client_id: manager.settings.client_id,
                    logout_uri: process.env.NEXT_PUBLIC_OIDC_POST_LOGOUT_URI as string,
                },
            });
        }
    }
});

export const apolloClient = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'no-cache',
            nextFetchPolicy: 'no-cache',
        },
    },
});
